module.exports = __webpack_public_path__ + "img/icon2.080678e.png";